import { Text } from "mondrian-react";
import React from "react";
import styled from "styled-components";
const Wrapper = styled.div`
  margin-top: 24px;
  max-width: 600px;

  .cred-ShortcutList-group {
    display: inline-flex;
    flex: 1;
    flex-direction: row;
    align-items: unset;
    flex-wrap: wrap;
  }

  .cred-ShortcutList-link {
    // Equivalentes resolvidos dos tokens do Mondrian 6. O Vanilla 5 ainda
    // carregado no ambiente expõe alguns aliases com referências incompletas.
    background: #ffffff;
    border: 1px solid #dbdbdb;
    border-radius: 12px;
    box-shadow: 0 4px 8px -2px rgba(31, 29, 29, 0.16);
    color: #1f1d1d;
    cursor: pointer;
    display: inline-flex;
    flex-direction: column;
    height: 138px;
    justify-content: space-between;
    margin-bottom: 16px;
    margin-right: 16px;
    padding: 12px;
    text-decoration: none;
    transition: scale 0.2s ease-in;
    width: 138px;

    &:hover {
      background-color: #f8f8f8;
      border-color: #dbdbdb;
      transition: all 0.2s;
    }

    &:active:not([disabled]):not([aria-disabled="true"]) {
      scale: 0.95;
    }

    html.mdn-Theme--contrast & {
      background: #000000;
      border-color: #ffffff;
      box-shadow: none;
      color: #fff333;
    }

    html.mdn-Theme--contrast &:hover {
      background: #000000;
      border-color: #fff333;
    }
  }

  .cred-ShortcutList-logo {
    align-self: flex-start;
    max-height: 50px;
    max-width: 85px;
  }

  .cred-ShortcutList-title {
    margin-bottom: 16px;
  }

  .cred-ShortcutList-description {
    line-height: 15px;
  }

  @media (min-width: 360px) {
    .cred-ShortcutList-link {
      height: 154px;
      width: 154px;
    }
  }

  @media (min-width: 1024px) {
    .cred-ShortcutList-link {
      height: 160px;
      width: 160px;
    }
  }
`;
export default function ShortcutListLinks({ links, firstTab }) {
  if (!links) return null;

  return (
    <Wrapper>
      <Text className="cred-ShortcutList-title">Você também pode acessar:</Text>
      <div className="cred-ShortcutList-group">
        {links.map(
          ({ title, description, href, target = "_self", logo }, index) => (
            <a
              key={`shortcut-${index}`}
              className="cred-ShortcutList-link"
              target={target}
              href={href}
              title={`Ir para ${title}`}
              tabIndex={!firstTab ? -1 : 30 + index}
            >
              <img
                className="cred-ShortcutList-logo"
                src={logo}
                alt={`Logo ${title}`}
              />
              <p className="cred-ShortcutList-description">{description}</p>
            </a>
          )
        )}
      </div>
    </Wrapper>
  );
}
